import { ChangeDetectorRef, Component, EventEmitter, inject, Output } from '@angular/core';
import { CourtFilterService } from '../court-filter.service';
import { CatalogoFiltroExpediente, FiltroExpediente, LstCatalogoFiltroExpediente } from '../court-filter.class';
import { AppModule } from '../../../../app-module';
import { TypeFilterService } from '../court-filter.enums';
import { AuthService } from '../../../services/auth.service';

@Component({
    selector: 'oaj-occ-filter',
    templateUrl: './occ.filter.component.html',
    styleUrls: ['./occ.filter.component.css'],
    providers: [CourtFilterService, AuthService],
    imports: [AppModule]
})
export class OccFilterComponent{

    @Output() FilterSelect!: EventEmitter<FiltroExpediente>;
    lstFiltersEdos: LstCatalogoFiltroExpediente = new LstCatalogoFiltroExpediente();
    lstFiltersOCC: LstCatalogoFiltroExpediente = new LstCatalogoFiltroExpediente();
    filter: FiltroExpediente = new FiltroExpediente;

    //ID's Seleccionados
    IdCircuitoSel: number | undefined;
    IdOrganoSel: number | undefined;
    itipovistaorgano: number | null = null;

    private service: CourtFilterService = inject(CourtFilterService); 
    private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
    private authService: AuthService = inject(AuthService);

    constructor() {
        this.FilterSelect = new EventEmitter();
        this.itipovistaorgano = this.authService.getClasificacionOrg() == 18 ? 2 : 3;
        this.IniciaEntidadCircuitos();
    }

    /**
     * Inicializa el filtro de circuitos, se asignan valores predeterminados a las propiedades del filtro, luego se llama a la función getFilter para obtener los datos de los circuitos y regiones utilizando el servicio de filtros, una vez obtenida la respuesta se asigna la lista de filtros de estados con los datos obtenidos y se detectan los cambios en la vista
     */
    IniciaEntidadCircuitos() {
        this.filter.IdAmbito = 1;
        this.filter.IdClasificacion = 9;
        this.filter.IdTipoFiltro = 9;
        this.filter.IdCircuito = 0;
        this.filter.IdEstado = 0;
        this.filter.IdTipoOrganismo = 0;
        this.filter.IdMateria = 0;
        this.filter.IdOrgano = 0;
        this.filter.itipovistaorgano = 0;
        this.getFilter(TypeFilterService.CircuitosRegiones);
    }


    /**
     * Obtiene los filtros según el tipo especificado
     * @param TypeFilter 
     * @returns 
     */
    getFilter(TypeFilter: TypeFilterService): Promise<boolean> {
        return new Promise((resolve) => {

            this.service.getFiltro(this.filter, TypeFilter)
                .subscribe((response: any) => {
                    if (response) {
                        if (response?.Data?.$values) {
                            switch (TypeFilter) {
                                case TypeFilterService.CircuitosRegiones:

                                    this.lstFiltersEdos.data = new Array<CatalogoFiltroExpediente>();
                                    this.lstFiltersEdos.data = response.Data.$values;
                                    this.changeDetectorRef.detectChanges();
                                    resolve(true);
                                    break;
                                case TypeFilterService.OCC:
                                    this.lstFiltersOCC.data = new Array<CatalogoFiltroExpediente>();
                                    this.lstFiltersOCC.data = response.Data.$values;
                                    this.changeDetectorRef.detectChanges();
                                    resolve(true);
                                    break;
                            }


                        } else {
                            resolve(false);
                        }
                    } else {
                        resolve(false);
                    }
                });
        });
    }

    /**
     * Maneja el cambio en el selector de circuitos/regiones
     * @param ddlValue 
     * @returns 
     */
    onChangeCircuitRegion(ddlValue: any): void {
        //console.log("onChangeCircuitRegion:::", ddlValue.target.value);
        // if (ddlValue.target.value == '0') return;
        if (ddlValue == '0') return;
        this.clearSelect(2);
        //this.filter.IdCircuito = Number(ddlValue.target.value);
        this.filter.IdCircuito = Number(ddlValue);
        this.filter.IdEstado = 0;
        this.filter.IdTipoOrganismo = 0;
        this.filter.IdMateria = 0;
        this.filter.IdOrgano = 0;
        this.filter.bTodasOCC = true;
        this.filter.itipovistaorgano = this.itipovistaorgano ?? 0;
        this.getFilter(TypeFilterService.OCC);

    }

    /**
     * Limpia el selector seleccionado
     * @param comboSelected 
     */
    clearSelect(comboSelected: number): void {
        switch (comboSelected) {
            case 2: //Circuito / Regiones
                this.IdOrganoSel = undefined;
                break;
        }
    }

    /**
     * Maneja el cambio en el selector de organismos
     * @param ddlValue 
     */
    onChangeOrganism(ddlValue: any): void {
        //  this.filter.IdOrgano = Number(ddlValue.target.value);
        this.filter.IdOrgano = Number(ddlValue);
        this.FilterSelect.emit(this.filter);
    }




}